import { Control, useWatch } from 'react-hook-form';

import { useTranslate } from '@/hooks/useTranslate';

import { TotalLine } from '../common';
import { AssetFormValues } from './type';

type AssetsTotalLineProps = {
  control: Control<AssetFormValues>;
  currencyDisplay: string;
};

export function AssetsTotalLine({
  control,
  currencyDisplay,
}: Readonly<AssetsTotalLineProps>) {
  const { t } = useTranslate();
  const watchedAssets = useWatch({ control, name: 'assets' });

  const total = (watchedAssets ?? []).reduce(
    (sum, asset) => sum + (asset?.amount ? Number(asset.amount) : 0),
    0,
  );

  return (
    <TotalLine
      label={t('moreInfo.form.yourFinances.assets.totalLabel')}
      value={`${currencyDisplay} ${total}`}
    />
  );
}
